import React from 'react';
import PropTypes from 'prop-types';
import { NavLink, useRouteMatch } from 'react-router-dom';
import { useRegionalLink } from 'hooks/useRegionalLink';

import SatisfactionItem from './SatisfactionItem/SatisfactionItem';

import classes from './SatisfactionItems.module.scss';

const SatisfactionItems = ({ items }) => {
  const { url } = useRouteMatch();
  const generateRegionalPath = useRegionalLink();

  let newUrl = url.split('/');
  newUrl.pop();
  newUrl = newUrl.join('/');

  return (
    <section className={classes.wrap}>
      {items.map(item =>
        item.disabled ? (
          <div className={classes.link} key={item.url}>
            <SatisfactionItem item={item} />
          </div>
        ) : (
          <NavLink
            to={generateRegionalPath(`${url}/${item.url}`)}
            className={classes.link}
            key={item.url}
          >
            <SatisfactionItem item={item} />
          </NavLink>
        )
      )}
    </section>
  );
};

SatisfactionItems.propTypes = {
  items: PropTypes.array
};

export default SatisfactionItems;
